import { useTranslation } from "react-i18next";
import { WhatsappLogo } from "@phosphor-icons/react";
import { buildWhatsAppUrl, trackWhatsAppClick } from "../lib/whatsapp";

/** Bottom-of-page WhatsApp call to action. Replaces the old LeadForm on inner pages. */
export const WhatsAppCtaBanner = ({ source = "page_bottom", contextText = "" }) => {
  const { t } = useTranslation();
  return (
    <section
      data-testid="whatsapp-cta-banner"
      className="relative py-20 lg:py-28 bg-[#2F3F2D] text-[#F6F5F2] overflow-hidden"
    >
      <div className="absolute -top-32 -right-32 w-[28rem] h-[28rem] rounded-full bg-[#A7CA99]/15 blur-3xl pointer-events-none" />
      <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#A7CA99]/20 border border-[#A7CA99]/40 mb-7">
          <span className="w-2 h-2 rounded-full bg-[#A7CA99] animate-pulse" />
          <span className="text-[11px] uppercase tracking-[0.22em] text-[#A7CA99] font-medium">
            {t("whatsapp_cta.eyebrow", "Conversa direta")}
          </span>
        </div>
        <h2 className="font-serif text-4xl lg:text-5xl xl:text-6xl font-light tracking-tight leading-[1.05] text-[#F6F5F2]">
          {t("whatsapp_cta.title_l1", "Tire dúvidas")}
          <br />
          <span className="italic text-[#A7CA99]">{t("whatsapp_cta.title_l2", "no WhatsApp.")}</span>
        </h2>
        <p className="mt-6 text-[#F6F5F2]/75 font-light leading-relaxed max-w-xl mx-auto">
          {t(
            "whatsapp_cta.body",
            "Fale com a nossa equipa em poucos minutos. Resposta humana, sem compromisso."
          )}
        </p>
        <a
          href={buildWhatsAppUrl(contextText)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackWhatsAppClick(source)}
          data-testid="whatsapp-cta-banner-button"
          className="mt-10 inline-flex items-center gap-3 px-8 py-4 bg-[#25D366] hover:bg-[#1DA851] text-white text-xs uppercase tracking-[0.22em] transition-colors"
        >
          <WhatsappLogo size={18} weight="fill" />
          {t("whatsapp.start", "Iniciar conversa")}
        </a>
        <div className="mt-4 text-xs text-[#F6F5F2]/55 font-light">
          {t("contact.phone_value")}
        </div>
      </div>
    </section>
  );
};
